import React from 'react';
const loader = () => <></>;

export default loader;
